<template>
  <GlassCard class="col-lg-2 mb-5 py-3">
    <div class="row mt-4 pt-2 m-2">
      <div class="col-sm-12 col-md-12 form-group text-left pb-0 mb-0">
        <h4 class="text-center" style="font-size: 1rem; line-height: 24px">
          {{ authorize ? template.ssoCardTitle : template.cardTitle }}

          <br />

          Aguarde, logout em andamento...
        </h4>
      </div>

      <section class="col-12 text-center">
        <LoadingRing />
      </section>
    </div>
  </GlassCard>
</template>

<script>
import { getSSORedirectUrl } from '@/helpers/ssoHelper'
export default {
  name: 'Logout',
  computed: {
    goToHomePage() {
      return getSSORedirectUrl(this.config)
    },
  },
  mounted() {
    localStorage.removeItem('session')
    this.$router.push(this.goToHomePage)
  },
}
</script>
